<div class="maintenance-container">
  <div class="maintenance-card">
    <!-- Lock Icon -->
    <!-- <div class="icon-container">
      <div class="lock-icon">
        <em class="pi pi-sync"></em>
      </div>
    </div> -->

    <!-- Title -->
    <h1 class="maintenance-title">Under Maintenance</h1>
    <h2 class="maintenance-subtitle">We'll be back shortly</h2>
    <!-- Description -->
    <p class="maintenance-description">
      We're currently performing scheduled maintenance<br>
      to improve your experience. We'll be back online<br>
      shortly.
    </p>

    <!-- Maintenance Status -->
    <div class="maintenance-progress">
      <span class="status-dot"></span>
      <span>Maintenance in Progress</span>
    </div>

    <!-- Check Status Button -->
    <a href="https://statuspage.incident.io/neohire" target="_blank" rel="noopener noreferrer" class="status-button">
      <!-- <em class="pi pi-external-link status-button-icon"></em> -->
      <span>Check Status</span>
    </a>

    <!-- Separator Line -->
    <div class="separator-line"></div>

    <!-- Team NeoHire -->
    <div class="team-section">
      <span>Team <span class="neohire-text">NeoHire</span></span>
    </div>
    <div>
      <span>For support  <a href="mailto:neohire-support@iamneo.ai" class="neohire-text">neohire-support&#64;iamneo.ai</a></span>
    </div>
  </div>

  <!-- Thank you message -->
  <p class="thank-you-message">Thank you for your patience</p>
</div>